import { prepEq } from "../PrepMenuOptions";
import { useEffect, useRef, useState } from "react";
export function useFixer(props) { const [fix, setFix] = useState(false); const autoFixRef = useRef(props.autoFix); autoFixRef.current = props.autoFix; const onChangeRef = useRef(props.onChange); onChangeRef.current = props.onChange; const propsValue = props.value; useEffect(() => { const fix = !prepEq(propsValue, Object.assign({}, propsValue, autoFixRef.current(propsValue))); if (fix) {
    onChangeRef.current(autoFixRef.current(propsValue));
    setFix(true);
} }, [propsValue]); return fix; }
